import { render, staticRenderFns } from "./PurchaseRecordList.vue?vue&type=template&id=cff42744&scoped=true&"
import script from "./PurchaseRecordList.vue?vue&type=script&lang=js&"
export * from "./PurchaseRecordList.vue?vue&type=script&lang=js&"
import style0 from "./PurchaseRecordList.vue?vue&type=style&index=0&id=cff42744&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cff42744",
  null
  
)

export default component.exports